import * as React from 'react';
import { isNullOrUndefined } from 'util';
/**
 * A useState like hook for boolean values that returns the state, and a ToggleStateAction instead of a SetStateAction that allows
 * the setState callback to be called without passing any arguments to simply toggle the boolean value.
 *
 * @param initialState
 */
export function useToggleState(initialState) {
    var _a = React.useState(initialState !== null && initialState !== void 0 ? initialState : false), state = _a[0], setState = _a[1];
    var toggle = React.useCallback(function (value) {
        setState(function (prevState) {
            // If we are being told which value to use, use it
            if (!isNullOrUndefined(value)) {
                if (value instanceof Function) {
                    return value(prevState);
                }
                return value;
            }
            // Otherwise simply toggle the value.
            return !prevState;
        });
    }, [setState]);
    return [state, toggle];
}
//# sourceMappingURL=useToggleState.js.map